if (!customElements.get('ec-sticky-add-to-cart')) {
  customElements.define(
    'ec-sticky-add-to-cart',
    class EcStickyAddToCart extends HTMLElement {
      constructor() {
        super();
        // Move to <body> so no ancestor with a scroll-reveal transform (which creates a
        // new containing block) can trap this fixed-position bar away from the viewport.
        document.body.appendChild(this);

        this.sectionId = this.dataset.section;
        this.submitButton = document.getElementById(this.dataset.submitButton);
        this.quantityInput = document.getElementById(this.dataset.sourceQuantity);
        this.priceSource = document.getElementById(this.dataset.priceSource);

        this.ownSubmitButton = this.querySelector('.ec-sticky-atc__submit');
        this.ownSpinner = this.querySelector('.ec-sticky-atc__submit .loading__spinner');
        this.ownPrice = this.querySelector('.ec-sticky-atc__price');
        this.ownQtyValue = this.querySelector('.ec-sticky-atc__qty-value');
        this.ownMediaImg = this.querySelector('.ec-sticky-atc__media img');
        this.ownVariantText = this.querySelector('.ec-sticky-atc__variant');
        this.minusBtn = this.querySelector('[data-step="minus"]');
        this.plusBtn = this.querySelector('[data-step="plus"]');

        this.bindEvents();
        this.observeSubmitButtonState();
        this.observeVariantChange();
        this.observeTrigger();
        this.syncQuantity();
      }

      bindEvents() {
        this.minusBtn?.addEventListener('click', () => {
          this.quantityInput?.closest('quantity-input')?.querySelector('button[name="minus"]')?.click();
        });
        this.plusBtn?.addEventListener('click', () => {
          this.quantityInput?.closest('quantity-input')?.querySelector('button[name="plus"]')?.click();
        });
        this.ownSubmitButton?.addEventListener('click', () => {
          this.submitButton?.click();
        });
        this.quantityInput?.addEventListener('change', this.syncQuantity.bind(this));
      }

      syncQuantity() {
        if (!this.quantityInput || !this.ownQtyValue) return;
        this.ownQtyValue.textContent = this.quantityInput.value;
      }

      syncSubmitState() {
        if (!this.submitButton || !this.ownSubmitButton) return;
        this.ownSubmitButton.toggleAttribute('disabled', this.submitButton.hasAttribute('disabled'));

        const isLoading = this.submitButton.classList.contains('loading');
        this.ownSubmitButton.classList.toggle('loading', isLoading);
        this.ownSpinner?.classList.toggle('hidden', !isLoading);
      }

      observeSubmitButtonState() {
        if (!this.submitButton) return;
        this.syncSubmitState();
        new MutationObserver(this.syncSubmitState.bind(this)).observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
        });
      }

      observeVariantChange() {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== this.sectionId) return;
          this.updateFromVariant(event.data.variant);
        });
      }

      updateFromVariant(variant) {
        if (!variant) return;

        if (this.ownVariantText) this.ownVariantText.textContent = variant.title || '';
        if (this.ownMediaImg && variant.featured_image?.src) this.ownMediaImg.src = variant.featured_image.src;

        this.priceSource = document.getElementById(this.dataset.priceSource);
        if (this.priceSource && this.ownPrice) this.ownPrice.innerHTML = this.priceSource.innerHTML;

        this.quantityInput = document.getElementById(this.dataset.sourceQuantity);
        this.submitButton = document.getElementById(this.dataset.submitButton);
        this.syncQuantity();
        this.syncSubmitState();
        this.observeSubmitButtonState();
        this.observeTrigger();
      }

      observeTrigger() {
        this.triggerObserver?.disconnect();
        if (!this.submitButton) {
          this.classList.remove('ec-sticky-atc--visible');
          return;
        }

        this.triggerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('ec-sticky-atc--visible', passed);
            });
          },
          { threshold: 0 }
        );
        this.triggerObserver.observe(this.submitButton);
      }
    }
  );
}
